export default __webpack_public_path__ + "0efd9bdba83e6e8e8bd27977348d5977.svg";